import type { BookingsOverviewData, Booking as DomainBooking } from '../../domain/types'
import type { BookingsOverviewAPIResponse } from '../types'
import { ACCOUNT_BOOKING_DEFAULT_IMAGE_SRC } from '@/scopes/account/common/constants'
import { formatDestination, formatPeriod } from '@/scopes/account/common/formatters'
import { isBookingCancelled } from './utils'

export function mapCancelledBookings(
  apiBookings: BookingsOverviewAPIResponse,
): BookingsOverviewData['cancelledBookings'] {
  const result: Record<string, DomainBooking> = {}

  apiBookings
    .filter(booking => !booking.isOnRequest && isBookingCancelled(booking.status))
    .forEach((booking) => {
      const mapped: DomainBooking = {
        bookingNumber: booking.bookingNumber.toString(),
        accommodationName: booking.accommodationName,
        destination: formatDestination(booking.destinationInformation),
        period: formatPeriod(booking.departureDate, booking.returnDate),
        imageSrc: booking.imageSrc || ACCOUNT_BOOKING_DEFAULT_IMAGE_SRC,
        rawDepartureDate: booking.departureDate,
        showNewBookingDetailPage: !booking.isGroupBooking,
      }

      result[mapped.bookingNumber] = mapped
    })

  return result
}
